// Says whether the design on screen is saved (#316). Restyles save as you go,
// with no button, so without this the only proof that a change landed was the
// thumbnail in "Your codes", below the builder. `status` is QrBuilder's
// restyleStatus. The live region stays mounted while idle so the first change
// is announced.
const LOOKS = {
  saving:  { label: "Saving…",        chip: "bg-cloud text-[color:var(--color-muted)] dark:bg-slate dark:text-muted-light" },
  saved:   { label: "Saved",          chip: "bg-voltage-pale text-voltage-deep dark:bg-voltage/15 dark:text-voltage-light" },
  // A change the server refused on purpose (a low-contrast pair, refused
  // text). The field says why; this only says the file did not change.
  unsaved: { label: "Not saved",      chip: "bg-warn/10 text-coal dark:text-cloud" },
  error:   { label: "Couldn't save",  chip: "bg-fail/10 text-coal dark:text-cloud" },
}

export default function SaveStatus({ status = "idle", className = "" }) {
  const look = LOOKS[status]
  return (
    <span role="status" aria-live="polite" className={className}>
      {look && (
        <span className={"inline-flex items-center gap-1.5 min-h-[28px] px-2.5 rounded-full text-xs font-semibold whitespace-nowrap " + look.chip}>
          {status === "saving" && (
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true" className="motion-safe:animate-spin">
              <path d="M21 12a9 9 0 1 1-6.22-8.56" />
            </svg>
          )}
          {status === "saved" && (
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          )}
          {status === "unsaved" && <span aria-hidden="true" className="w-2 h-2 rounded-full bg-warn" />}
          {status === "error" && <span aria-hidden="true" className="w-2 h-2 rounded-full bg-fail" />}
          {look.label}
        </span>
      )}
    </span>
  )
}
